export default __webpack_public_path__ + "static/Win-59f987dc0754141419d42708d81255f2.gif";